export default function daysLeft(user) {
  // console.log(10);
  // return 5;

  let balance = user?.accountBalance ?? 0;
  let daysTotal = 0;
  const discounts = user?.tariffInfo ?? [];

  while (discounts.length) {
    const discount = discounts.shift();
    let days = discount.days ?? 0;
    const price = discount.price ?? 0;

    while (days > 0 && balance >= price) {
      daysTotal += 1;
      days -= 1;
      balance -= price;
    }
  }

  const price = user?.tariff?.pricePerDay ?? 1;
  daysTotal += Math.floor(balance / price);
  return daysTotal;
}
